module.exports = __webpack_public_path__ + "img/logo33-frame.2f74e0be.png";